<template>
  <div class='SelectFont'>
    <div class="label">
      <div class="text-label">Fonte Padrão:</div>
      <div class="arrow">
        <arrow-icon @showSubLinks="newValue => sublink = newValue"/>
      </div>
    </div>
    <div class="cont-select" :class="{ contselect: sublink }">
      <div class="cont-s">
        <input-select
        :value="Prefes.global.font"
        :data="Fonts"
        @update:modelValue="newValue => UpdateFontDefault(newValue)"
        :label="{ display: 'none' }"
        :input="{ width: '100%', padding: '2%', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputSelect from '../Produtos/Register/InputSelect'
import ArrowIcon from '../Icons/ArrowIcon'
export default {
  name: 'SelectFont',
  components: { InputSelect, ArrowIcon },
  data () {
    return {
      sublink: false
    }
  },
  computed: {
    ...mapGetters(['Fonts', 'Prefes'])
  },
  methods: {
    ...mapActions(['UpdateFontDefault'])
  }
}
</script>

<style scoped>
.SelectFont {
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.label {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
  text-align: left;
  color: #648EEA;
  font-size: 16px;
}

.text-label {
  width: 90%;
  padding: 2%;
}

.cont-select {
  max-height: 0px;
  border-radius: 5px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.contselect {
  border-radius: 5px;
  /* padding: 3%;
  margin-top: 1%; */
  max-height: 200px;
  transition: max-height 0.4s ease-in;
}

.cont-s {
  padding: 3.3%;
}
</style>